import type {
  DTOExposeNotificationsRequest,
  DTOHideNotificationsRequest,
  DTOListNotificationParams,
  DTOListNotificationResponse,
  DTONotificationFilterResponse,
} from 'src/apis/dto/DTONotification';

import type { APIClientType } from '.';

export class NotificationService {
  private client: APIClientType;

  constructor(customClient: APIClientType) {
    this.client = customClient;
  }

  /**
   * 알림 목록 조회
   */
  public listNotifications = async (data?: DTOListNotificationParams) => {
    return this.client.call<DTOListNotificationResponse, DTOListNotificationParams>({
      method: 'GET',
      path: '/promotion/v1/notifications/list',
      data,
    });
  };

  /**
   * 알림 목록의 상태를 '노출됨'으로 변경
   */
  public exposeNotifications = async (data: DTOExposeNotificationsRequest) => {
    return this.client.call<void, DTOExposeNotificationsRequest>({
      method: 'POST',
      path: '/promotion/v1/notifications/list',
      data,
    });
  };

  /**
   * 알림 목록의 상태를 '숨김'으로 변경.
   * 현재 Android/iOS 네이티브 앱에서는 미사용 (스와이프 삭제 등 UI 없음).
   * 추후 삭제 기능 도입 시 사용 예정.
   */
  public hideNotifications = async (data: DTOHideNotificationsRequest) => {
    return this.client.call<void, DTOHideNotificationsRequest>({
      method: 'DELETE',
      path: '/promotion/v1/notifications/list',
      data,
    });
  };

  /**
   * 알림 필터 목록 조회
   */
  public getFilters = async () => {
    return this.client.call<DTONotificationFilterResponse, void>({
      method: 'GET',
      path: '/promotion/v1/notifications/filters',
    });
  };
}
